import { render, staticRenderFns } from "./TableDataWithIcon.vue?vue&type=template&id=114d2ba7&"
import script from "./TableDataWithIcon.vue?vue&type=script&lang=js&"
export * from "./TableDataWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports